import React from "react";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { CustomTooltip } from "./styles";

const ButtonWithTooltip = ({ tooltipText, placement = "top", children, ...props }) => {
  if (!tooltipText) {
    // Se não houver tooltipText, renderize apenas o botão sem o OverlayTrigger
    return <Button {...props}>{children}</Button>;
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<CustomTooltip id="button-tooltip">{tooltipText}</CustomTooltip>}
    >
      <Button {...props}>{children}</Button>
    </OverlayTrigger>
  );
};

export default ButtonWithTooltip;
